class CarouselBanner extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.slides = this.querySelectorAll('.carousel-banner__slide');
    this.slidesContainer = this.querySelector('.carousel-banner__slides');
    this.prevButton = this.querySelector('.carousel-banner__nav--prev');
    this.nextButton = this.querySelector('.carousel-banner__nav--next');

    // Find dots container outside of carousel-banner element
    this.dotsContainer = this.parentElement.querySelector('.carousel-banner__dots');
    this.dots = this.dotsContainer ? this.dotsContainer.querySelectorAll('.carousel-banner__dot') : [];

    this.init();
  }

  init() {
    if (this.slides.length <= 1) {
      // Hide navigation if only one slide
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
      if (this.dotsContainer) this.dotsContainer.style.display = 'none';
      return;
    }

    // Add event listeners
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.goToPrevSlide());
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.goToNextSlide());
    }

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Touch events for swipe
    let touchStartX = 0;
    let touchEndX = 0;

    this.slidesContainer.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    });

    this.slidesContainer.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    });

    // Keyboard navigation
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.goToPrevSlide();
      } else if (e.key === 'ArrowRight') {
        this.goToNextSlide();
      }
    });

    // Show initial slide
    this.updateSlidePosition();
  }

  handleSwipe(startX, endX) {
    const threshold = 50; // minimum distance for swipe
    const difference = startX - endX;

    if (Math.abs(difference) > threshold) {
      if (difference > 0) {
        // Swipe left - next slide
        this.goToNextSlide();
      } else {
        // Swipe right - previous slide
        this.goToPrevSlide();
      }
    }
  }

  goToSlide(index) {
    this.currentSlide = index;
    this.updateSlidePosition();
  }

  goToNextSlide() {
    this.currentSlide = (this.currentSlide + 1) % this.slides.length;
    this.updateSlidePosition();
  }

  goToPrevSlide() {
    this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length;
    this.updateSlidePosition();
  }

  updateSlidePosition() {
    const offset = -this.currentSlide * 100;
    this.slidesContainer.style.transform = `translateX(${offset}%)`;

    // Update dots
    this.dots.forEach((dot, index) => {
      if (index === this.currentSlide) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    // Update aria-hidden for accessibility
    this.slides.forEach((slide, index) => {
      if (index === this.currentSlide) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }
}

customElements.define('carousel-banner', CarouselBanner);
